import { FormProvider, useForm, type FieldErrors } from 'react-hook-form'

import { CloseIcon } from '@assets/svgs/CloseIcon'
import { FilterIcon } from '@assets/svgs/FilterIcon'
import { Button } from '@components/shared/Button'
import { Input } from '@components/shared/Input'
import { RowBox } from '@components/shared/RowBox'
import { Select } from '@components/shared/Select'
import { useUsers } from '@pages/Users/context'
import { initialFormValues } from './form/initialFormValues'

import type { UsersFiltersFormProps } from './form/types'
import type { UsersFiltersProps } from './types'

import * as S from './styles'

export const UsersFilters = ({ onFilter }: UsersFiltersProps) => {
  const { usersData, isUsersLoading } = useUsers()

  const methods = useForm<UsersFiltersFormProps>({
    defaultValues: initialFormValues
  })

  const onError = (errors: FieldErrors<UsersFiltersFormProps>) => console.log({ errors })

  const onSubmit = (formData: UsersFiltersFormProps) => onFilter(formData)

  return (
    <FormProvider {...methods}>
      <RowBox columns={5} marginTop={48} marginBottom={24}>
        <Input name="code" label="Código" placeholder="Código" />

        <Input name="user" label="Usuário" placeholder="Nome, E-mail" />

        <Select
          name="role"
          label="Cargo"
          options={
            usersData?.availableFilters?.positions.map((position) => ({
              label: position,
              value: position
            })) || []
          }
        />
        <Select
          name="profile"
          label="Perfil"
          options={
            usersData?.availableFilters?.profiles.map((profile) => ({
              label: profile.profileDescription,
              value: profile.id.toString()
            })) || []
          }
        />

        <S.FilterButtons>
          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<FilterIcon />}
            onClick={() => methods.handleSubmit(onSubmit, onError)()}
            disabled={isUsersLoading}
          >
            Filtrar
          </Button>

          <Button
            width="100%"
            colorType="outlineBlue"
            rightIcon={<CloseIcon />}
            onClick={() => {
              methods.reset()
              onFilter(initialFormValues)
            }}
            disabled={isUsersLoading}
          >
            Limpar
          </Button>
        </S.FilterButtons>
      </RowBox>
    </FormProvider>
  )
}
